import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';

@Injectable()
export class LicensesActivityService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/crawler/licenses/activity');
  }
}
